/**
 * A contestant record can exist (e.g. created by admin with just a name)
 * without being complete. Only a complete profile locks the contestant's
 * own registration fields.
 */
export function isContestantProfileComplete(contestant) {
  return Boolean(
    contestant?.id &&
      contestant?.full_name &&
      contestant?.age &&
      contestant?.email &&
      contestant?.mobile &&
      contestant?.bio &&
      contestant?.hometown &&
      contestant?.profession &&
      contestant?.platform_advocacy &&
      contestant?.hobbies
  );
}

export function ageFromDob(dob) {
  if (!dob) return "";
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return "";
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1;
  return age > 0 ? String(age) : "";
}

export function contestantAgeValue(contestant) {
  if (contestant?.age) return String(contestant.age);
  return ageFromDob(contestant?.dob);
}

/** Account first + last name (registration identity; not contestant.full_name). */
export function accountFullName(user) {
  if (!user) return "";
  return `${user.firstName || user.first_name || ""} ${
    user.lastName || user.last_name || ""
  }`.trim();
}

export function accountEmail(user) {
  return String(user?.email || "").trim();
}

/** Approximate DOB for APIs that still expect a date field. */
export function dobFromAge(age) {
  const n = Number(age);
  if (!n || n < 1 || n > 120) return "";
  const year = new Date().getFullYear() - n;
  return `${year}-01-01`;
}
